import { Pipe, PipeTransform, OnInit,ConstructorProvider } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-hijri';
import momentG from 'moment';
import { BaseService } from '../services/BaseService';

@Pipe({
  name: 'hijriDate'
})
export class HijriDatePipe extends DatePipe implements PipeTransform, OnInit {
  currentLang = this.baseService.currentLang || localStorage.getItem('lang') || 'ar';
  constructor(private baseService: BaseService,){
    super(null);

  }
  ngOnInit(): void {
    
    this.baseService.getLangData().subscribe(data => {
      this.changeLagView(data.lang);

     });

  }
  changeLagView(lang){
    this.currentLang = lang;
  }
  override transform(value: any): any {
    const dayName =  momentG(value).locale(this.currentLang).format('ddd');


    let hijrieorGianDate = '';
    if(this.currentLang == 'ar'){
      const hijriDate = moment(value).locale('en').format('iYYYY/iM/iD');
      const georgianDate = momentG(value).locale('en').format('DD/MM/YYYY');
  
      hijrieorGianDate = 'ال'+dayName+' ' +hijriDate + '   هـ' + " | " +  georgianDate +' م '
    }
    if(this.currentLang == 'en'){
      const hijriDate = moment(value).locale('en').format('iM/iD/iYYYY');
      const georgianDate = momentG(value).locale('en').format('DD/MM/YYYY');
  
      hijrieorGianDate = dayName+' ' +hijriDate + '   AH' + " | " +  georgianDate 
    }
    return hijrieorGianDate;
  }
}